import { Pipe, PipeTransform } from '@angular/core';

export interface CurrencyPipeOptions {
    precision?: number;
    symbol?: string;
    locale?: string;
}

const DEFAULT_LOCALE = 'pl-PL';

@Pipe({ name: 'sklCurrency' })
export class CurrencyPipe implements PipeTransform {
    public transform(value: number, options?: CurrencyPipeOptions): string {
        const precisionOptions = options?.precision
            ? { maximumFractionDigits: options.precision, minimumFractionDigits: options.precision }
            : { maximumFractionDigits: this.getMaxFractionDigits(value)};
        const locale = options?.locale ?? DEFAULT_LOCALE;
        const stringValue = new Intl.NumberFormat(locale, { ...precisionOptions }).format(value);

        const symbol = options?.symbol ? ` ${options.symbol}` : '';

        return `${stringValue.replace(/(^-?[1-9])([0-9]{3})/, "$1\u00A0\$2")}${symbol}`;
    }

    public getMaxFractionDigits(value: number): number {
        if (!value) return 0;

        const sign = value.toString().includes('.') ? '.' : value.toString().includes(',') ? ',' : null;
        if (!sign) return 0;
        return value.toString().split(sign)[1].length;
    }
}
